<div *ngIf="isloader" class="h-100 w-100 padt-5">
    <mat-progress-bar [mode]="'indeterminate'">
    </mat-progress-bar>
</div>
<div class="fancy-graph-align">
    <!-- <div class="vehicle-profile-header">Skin Temperature(°C) <span>{{sourceTimestamp}}</span>
    </div> -->
    <!-- <span>&nbsp;<img alt="Info"
                matTooltip="Asset safe within -20 °C and -30 °C" class="h-20px"
                src="../../../../assets/images/info-icon.svg">
        </span> -->

    <div class="vehicle-profile-header info-icon-align position-relative">
        <div>
            <div>{{widgetData?.title}}</div>
            <div class="ft-12">{{sourceTimestamp}}</div>
        </div>
        <div class="am-hover-controller position-relative" *ngIf="sensorId"><img alt="Info"
                src="../../../../assets/images/info-circle.svg">
        </div>
        <!--the hover-pop-->

        <div class="will-appear-on-hover bg-for-popout" id="hover-pop-dover1">
            <div class="d-flex">
                Data from {{sensorId}}
            </div>
        </div>
    </div>
    <!--hover pop ends-->


    <!-- graph for body vitals-->
    <div class="the-fancy-graph d-grid align-content-center"
        *ngIf="skinTemperature?.attributeValue && !isloader && !isError">
        <div class="groove">
            <div class="adjustable-indicator" [style.left.%]="attributeValueMarker"><sup class="sup-bg"
                    [ngClass]="{'bg-red': +skinTemperature?.attributeValue > upperAlertThreshold || +skinTemperature?.attributeValue < lowerAlertThreshold,
                     'bg-green': +skinTemperature?.attributeValue <= upperAlertThreshold && +skinTemperature?.attributeValue >= lowerAlertThreshold}"><span>{{skinTemperature?.attributeValue}}</span></sup>
            </div>
        </div>
        <div class="bar-club">
            <div class="red-bar"></div>
            <div class="green-bar values-below-the-bar" [attr.data-content1]="lowerAlertThreshold"
                [attr.data-content2]="upperAlertThreshold"></div>
            <div class="red-bar"></div>
        </div>
    </div>
    <div class="no-data-align" *ngIf="isloader || isError || !skinTemperature?.attributeValue">
        <p>No Data Available</p>
    </div>
</div>